import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import moment from 'vue-moment'
import VueGtag from 'vue-gtag'
import VueCookies from 'vue-cookies'

Vue.config.productionTip = false
Vue.use(VueGtag, {
    config: { id: "G-3PDH84TYDJ" },
    enabled: false
}, router);
Vue.use(VueCookies);
Vue.$cookies.config('7d');

new Vue({
  router,
  store,
  vuetify,
    render: h => h(App),

}).$mount('#app')
